export const PAGE_HEADER_TYPE_TEXT_HEADING = 'textHeading';
